import { LIGHT_LOGO_PATH, DARK_LOGO_PATH } from './constants'

export const getLogoPath = (type) => {
  if (type === 'light') return LIGHT_LOGO_PATH

  return DARK_LOGO_PATH
}
